import React from 'react';

import { FieldSet, Legend } from '@zillow/constellation-10';

import type { Section } from '../../../../models/index';
import { RESIDENT_ACTIVITIES, RESIDENT_ACTIVITIES_RULES } from '../../../../constants';
import AdditionalRulesTemplate from './AdditionalRulesTemplate';
import RulesCheckbox from './RulesCheckbox';

type Props = {
  section: Section;
  setSectionValues: (keyValuePairs: object) => void;
};

const CHECKED_STATE = {};

for (const key of Object.keys(RESIDENT_ACTIVITIES.FIELD_NAME)) {
  CHECKED_STATE[RESIDENT_ACTIVITIES.FIELD_NAME[key]] = true;
}

const UNCHECKED_STATE = {};

for (const key of Object.keys(RESIDENT_ACTIVITIES.FIELD_NAME)) {
  UNCHECKED_STATE[RESIDENT_ACTIVITIES.FIELD_NAME[key]] = false;
}

export default function ResidentActivities_v1({ section, setSectionValues }: Props): JSX.Element {
  function toggleResidentActivitiesRules(): void {
    const isEnabled = section.getFieldValue(RESIDENT_ACTIVITIES.FIELD_NAME.IS_ENABLED);
    const setCheckboxes = isEnabled ? UNCHECKED_STATE : CHECKED_STATE;

    setSectionValues({
      ...setCheckboxes,
    });
  }

  function onBoxClick(event): void {
    const { value } = event.currentTarget.dataset;
    const checked = section.getFieldValue(value);

    setSectionValues({ [value]: !checked });
  }

  const switchedOn = section.getFieldValue(RESIDENT_ACTIVITIES.FIELD_NAME.IS_ENABLED);

  return (
    <AdditionalRulesTemplate
      title="Resident activities"
      caption="You can select rules meant to help the tenants and occupants peacefully enjoy the property"
      switchTitle="Include activity rules"
      switchedOn={switchedOn}
      toggleSwitch={toggleResidentActivitiesRules}
    >
      {switchedOn && (
        <FieldSet optional legend={<Legend>Choose which of these optional rules to include with your lease</Legend>}>
          {RESIDENT_ACTIVITIES_RULES.map((rule, index) => {
            const { FIELD_NAME } = rule;
            const checked = section.getFieldValue(FIELD_NAME);

            return (
              <RulesCheckbox
                key={index}
                onBoxClick={onBoxClick}
                setSectionValues={setSectionValues}
                {...rule}
                checked={checked}
              />
            );
          })}
        </FieldSet>
      )}
    </AdditionalRulesTemplate>
  );
}

ResidentActivities_v1.description = 'No marijuana';
